// extracted by mini-css-extract-plugin
module.exports = {"bg":"BackgroundVideo-module--bg--3iqLM","fadeIn":"BackgroundVideo-module--fadeIn--2nr5P"};